<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Liste Commandes</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">N° Command</th>
          <th class="px-6 pt-6 pb-4">N° Order</th>
          <th class="px-6 pt-6 pb-4">Reçu par</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Pieces</th>
          <th class="px-6 pt-6 pb-4">Commentaire</th>
          <th class="px-6 pt-6 pb-4">Creation date</th>
        </tr>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100" @click="showForm(order)">
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer focus:text-indigo-500">
              {{ order.id }}
              <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ order.repair_id }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ order.user }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ order.model }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ order.stockReference }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ order.comment }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center cursor-pointer">
              {{ order.created_at }}
            </span>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No orders found.</td>
        </tr>
      </table>
      <!-- Return stock to siege -->
      <jet-dialog-modal :show="actionForm" max-width="sm" :closeable="false" @close="actionForm = false">
        <template #title>
          Action
        </template>
        <template #content>

        </template>
        <template #footer>
          <jet-secondary-button @click.native="actionForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green" :class="{ 'opacity-25': sending }"
                      :disabled="sending" @click.native="confirmOrder">
            Confirmer
          </jet-button>
          <jet-danger-button :class="{ 'opacity-25': sending }" :disabled="sending" @click.native="rejectOrder">
            Rejeter
          </jet-danger-button>
        </template>
      </jet-dialog-modal>
    </div>
    <pagination :links="orders.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetInput from '@/Jetstream/Input'

export default {
  metaInfo: {title: 'Commandes'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDialogModal,
    JetButton,
    JetSecondaryButton,
    JetInput,
    JetDangerButton
  },
  props: {
    errors: Object,
    orders: Object,
    filters: Object,
  },
  data() {
    return {
      selected: null,
      selectAll: false,
      sending: false,
      processing: false,
      actionForm: false,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('stock.orders', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    showForm(order) {
      this.actionForm = true
      this.selected = order
    },
    confirmOrder() {
      const data = new FormData()
      data.append('order', JSON.stringify(this.selected) || [])
      data.append('action', 'confirm')
      this.$inertia.post(this.route('stock.orders'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.actionForm = false
        },
        onSuccess: () => {
          this.selected = [];
        },
      })
    },
    rejectOrder() {
      const data = new FormData()
      data.append('order', JSON.stringify(this.selected) || [])
      data.append('action', 'reject')
      this.$inertia.post(this.route('stock.orders'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.actionForm = false
        },
        onSuccess: () => {
          this.selected = [];
        },
      })
    }
  },
}
</script>
